<template>
    <div>
        <v-app-bar dark absolute app flat color="primary" height="50" style="width: auto; margin-left:-35px" :key="view_trafico * 10 + view_costing * 100 + view_emanifiesto * 1000 + view_carta_porte * 10000 + soloCartaPorte + es_transportista + view_sa31 + view_sa24">
            <v-btn fab text left x-small v-if="!drawer" v-tippy title="Mostrar Barra Lateral" @click="setDrawer(!drawer)">
                <v-icon small>mdi-arrow-expand-right</v-icon>
            </v-btn>



             <!-- menus de super usuarios MX transmite-->
            <menuSuperUser />

            <!-- menu para usuarios de grupo normal con super panel activado-->
            <menuSuperPanel />

            <!-- menu grupo Transportista-->
            <menuTransportista/>

            <!-- menu grupo Agente Aduanal-->
            <menuAA/>

             <!-- menu clientes CARTA PORTE {eManifiestoCP}-->
            <menuEmanifiestoCP/>

             <!-- menu clientes MANIFESTACION DE VALOR {eManifiestoMV}-->
            <menuEmanifiestoMV/>

            <!-- menu clientes AGENCIA ADUANAL  {eManifiestoAA}-->
            <menuEmanifiestoAA/>

             <!-- menu clientes DESPACHO ADUANAL  {eManifiestoAA}-->
            <menuEmanifiestoDA/>


            <!-- menu clientes Ecosting-->
            <menuEcosting/>


            <!-- menu clientes Gestion de embarques-->
            <menuGestion/>

            <!-- menu clientes Analytics-->
            <menuAnalytics/>

            <!-- menu soluciona-->
            <menuSa31/>

            <!-- menu soluciona 24-->
            <menuSa24/>

            <v-spacer />


            <!-- publicaciones diario oficial -->
             <v-tooltip bottom v-if="!es_transportista && !soloCartaPorte && !soloSoluciona24">
                <template v-slot:activator="{ attrs, on }">
                    <v-btn v-bind="attrs" fab small text v-on="on" icon to="/DOF">
                        <v-icon>event</v-icon>
                    </v-btn>
                </template>
                <span>Publicaciones DOF</span>
            </v-tooltip>

            <!-- Notificaciones -->
            <v-menu bottom left offset-y origin="bottom left" width="500" transition="scale-transition" v-if="!is_consignatario && !soloSoluciona24">
                <template v-slot:activator="{ attrs, on }">
                    <v-btn fab dark small text v-bind="attrs" v-on="on">
                        <v-badge color="red" :offset-x="20" :offset-y="5" v-if="notificationsNumber!=0">
                            <template v-slot:badge>
                              <span class="caption" > <strong>{{ notificationsNumber > 99 ? '99+' : notificationsNumber }}</strong> </span>
                            </template>

                                <v-icon>mdi-bell</v-icon>
                        </v-badge>


                      <v-icon v-if="notificationsNumber == 0 ">mdi-bell</v-icon>


                    </v-btn>
                </template>

                <notification-list :key="this.$store.state.id_cliente + this.$store.state.datetime"></notification-list>

            </v-menu>

            <!-- Avatar Usuarios -->
            <v-menu text nav bottom left min-width="200" offset-y origin="top right" transition="scale-transition" style="z-index:10001">
                <template v-slot:activator="{ attrs, on }">
                    <v-btn min-width="0" icon text v-bind="attrs" v-on="on">
                        <v-avatar size="32px" :key="avatar">
                            <v-icon v-if="avatar == 'undefined'" medium>person</v-icon>
                            <img v-if="avatar != 'undefined'" :src="avatar" />
                        </v-avatar>
                    </v-btn>
                </template>

                <v-list :tile="false" text nav>
                    <template>
                        <app-bar-item to="/usuarios/perfil">
                            <v-icon>mdi-circle-small</v-icon>Editar Perfil
                        </app-bar-item>
                        <app-bar-item to="/usuarios/change">
                            <v-icon>mdi-circle-small</v-icon>Cambiar Contraseña
                        </app-bar-item>
                        <v-divider />
                        <app-bar-item @click.native="logout();">
                            <v-icon>mdi-circle-small</v-icon>Cerrar Sesión
                        </app-bar-item>
                    </template>
                </v-list>
            </v-menu>

            <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                    <v-btn v-bind="attrs" fab small text v-on="on" icon @click="handleFullScreen()">
                        <v-icon>fullscreen</v-icon>
                    </v-btn>
                </template>
                <span>Mostrar en pantalla completa</span>
            </v-tooltip>
        </v-app-bar>

    </div>
    </template>

    <script>

        import {
            VHover,
            VListItem
        } from "vuetify/lib";


        import {
            mapState,
            mapMutations
        } from "vuex";
        import NotificationList from "@/components/list/NotificationList";
        import menuSuperUser from "@/components/layout/MenuSuperUser";
        import menuSuperPanel from "@/components/layout/MenuSuperPanel";
        import menuTransportista from "@/components/layout/MenuTransportista";
        import menuAA from "@/components/layout/MenuAA";
        import menuEmanifiestoCP from "@/components/layout/MenuEmanifiestoCP";
        import menuEmanifiestoMV from "@/components/layout/MenuEmanifiestoMV";
        import menuEmanifiestoAA from "@/components/layout/MenuEmanifiestoAA";
        import menuEmanifiestoDA from "@/components/layout/MenuEmanifiestoDA";
        import menuEcosting from "@/components/layout/MenuEcosting";
        import menuGestion from "@/components/layout/MenuGestion";
        import menuAnalytics from "@/components/layout/MenuAnalytics";
        import menuSa31 from "@/components/layout/MenuSA31";
        import menuSa24 from "@/components/layout/MenuSA24";

        import Util from "@/util";
        import axios from "axios";
        import resize from "vue-resize-directive";

        export default {
        name: "DashboardCoreAppBar",

        directives: {
            resize
        },
        created() {

            if (!this.is_consignatario) {
                this.getNotificaciones();

                this.$root.$on("notificationsNumber", val => {
                    this.notificationsNumber = val;
                });
            }
            this.$local_storage.set("es_emanifiesto_logistico", this.$local_storage.get("EmanifiestoMV.bitacora") == 100);

        },
        components: {
            NotificationList,
            menuSuperUser,
            menuSuperPanel,
            menuTransportista,
            menuAA,
            menuEmanifiestoCP,
            menuEmanifiestoMV,
            menuEmanifiestoAA,
            menuEmanifiestoDA,
            menuEcosting,
            menuGestion,
            menuAnalytics,
            menuSa31,
            menuSa24,
            AppBarItem: {
                render(h) {
                    return h(VHover, {
                        scopedSlots: {
                            default: ({
                                hover
                            }) => {
                                return h(
                                    VListItem, {
                                        attrs: this.$attrs,
                                        class: {
                                            "black--text": !hover,
                                            "white--text secondary elevation-12": hover
                                        },
                                        props: {
                                            activeClass: "",
                                            dark: hover,
                                            link: true,
                                            ...this.$attrs
                                        }
                                    },
                                    this.$slots.default
                                );
                            }
                        }
                    });
                }
            }
        },

        props: {
            value: {
                type: Boolean,
                default: false
            }
        },

        data: () => ({
            fab: false,

            show_loading: false,
            notificationsNumber: 0,
            show: true,
            rfc: "",
            razon: "",
            tipo_usuario: "",
            id_cliente: 0,
            minifiedLeft: false,
            hiddenLeft: false,
            avatar: "undefined",
            fullWidth: document.documentElement.clientWidth,
            notifications: []
        }),

        computed: {
            ...mapState(["drawer"]),
            view_trafico() {
                return this.$store.state.trafico;
            },
            view_costing() {
                return this.$store.state.costing;
            },
            view_emanifiesto() {
                return this.$store.state.emanifiesto;
            },
            view_carta_porte() {
                return this.$store.state.carta_porte;
            },
            view_sa31() {
                return this.$store.state.sa31;
            },
            view_sa24() {
                return this.$store.state.sa24;
            },
            toolbarColor() {
                return this.$vuetify.options.extra.mainNav;
            },
            soloEcosting() {
                return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100;
            },
            soloEmanifiesto() {
                return this.$local_storage.get("DATA.STAGE.bitacora") != 100  &&
                    this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                    this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                    this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
                    (this.$local_storage.get("EmanifiestoMV.bitacora") == 100 || this.$local_storage.get("EmanifiestoMV.Logistica.bitacora") == 100) ;
            },
            es_transportista() {
                return this.$local_storage.get("es_transportista")==1 ;
            },
            rfc_transportista() {
                return this.$local_storage.get("rfc_grupo"); ;
            },
            Admin() {
                return (
                    this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                    this.$local_storage.get("id_cliente") == 0
                );
            },
            Legal() {
                return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales");
            },
            Pagos() {
                return (this.$local_storage.get("tipo_usuario") == "Pagos");
            },
            soloCartaPorte(){
                return (this.$local_storage.get("soloCartaPorte") == 100);
            },
            soloSoluciona24() {
                return this.$local_storage.get("soloSA24") == 100 ;
            },
            is_consignatario() {
                return this.$local_storage.get("perfil_grupo") == 43;
            },

            is_cliente() {
                return (
                    this.$local_storage.get("id_cliente") > 0
                );
            },

            esGrupo(){
                return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
            },

        },

        methods: {
            ...mapMutations({
                setDrawer: "SET_DRAWER"
            }),

            handleFullScreen() {
                Util.toggleFullScreen();
            },

            change() {
                this.$router.push("/usuarios/change").catch(() => {});
            },
            openNew: function (h) {
                window.open(h, "_blank");
            },

            logout() {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                var data = {
                    usuario: this.$local_storage.get("id_usuario"),
                    sistema: this.$sistema,
                    avatar: "undefined"
                };

                var url = this.$hostname + "usuarios/logout/";

                var self = this;
                axios
                    .post(url, data)
                    .then(function (response) {
                        let login = self.$local_storage.get("login");
                        window.localStorage.clear();
                        self.$local_storage.set("token", "");
                        self.$local_storage.set("id_usuario", 0);
                        self.$local_storage.set("tipo_usuario", "guest");
                        self.$user.set({
                            role: "guest"
                        });
                        self.$user.set({
                            id_cliente: "0"
                        });

                        self.$swal({
                            type: "success",
                            title: "Operación exitosa!",
                            text: "La sesión se cerró correctamente",
                            footer: ""
                        });
                        if(login == 1)
                            self.$router.push("/?emanifiesto").catch(() => {});

                        if(login == 2)
                            self.$router.replace("/?sa31").catch(() => {});

                        if(login == 3)
                                self.$router.replace("/?sa24").catch(() => {});

                        if(login == 0)
                            self.$router.push("/").catch(() => {});
                    })
                    .catch(function (error) {
                        window.localStorage.clear();
                        self.$local_storage.set("token", "");
                        self.$local_storage.set("id_usuario", 0);
                        self.$local_storage.set("tipo_usuario", "guest");
                        self.$user.set({
                            role: "guest"
                        });
                        self.$user.set({
                            id_cliente: "0"
                        });
                        self.$swal({
                            type: "error",
                            title: "Ocurrió un error!",
                            text: "Ocurrió un problema al cerrar la sesión",
                            footer: ""
                        });
                        if(self.$local_storage.get("login") == 1)
                            self.$router.push("/?emanifiesto").catch(() => {});

                        if(self.$local_storage.get("login") == 2)
                            self.$router.replace("/?sa31").catch(() => {});

                        if(self.$local_storage.get("login") == 3)
                                self.$router.replace("/?sa24").catch(() => {});

                        if(self.$local_storage.get("login") == 0)
                            self.$router.push("/").catch(() => {});



                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            },
            carga_datos() {
                this.rfc = this.$local_storage.get("rfc");
                this.razon = this.$local_storage.get("razon");
                this.tipo_usuario = this.$local_storage.get("tipo_usuario");
                this.id_cliente = this.$local_storage.get("id_cliente");
            },
            getNotificaciones: function () {
                let id_usuario = this.$local_storage.get("id_usuario");
                axios
                    .post(this.$hostname + "notificaciones/list_notificaciones/", {
                        usuario: id_usuario
                    })
                    .then(response => {
                        let notificaciones = response.data.filter(notificacion => {
                            return notificacion.estatus == 0;
                        });
                        this.$root.$emit("notificationsNumber", notificaciones.length);
                    })
                    .catch(error => {
                        console.log(error);
                        this.$root.$emit("notificationsNumber", 0);
                    });
            },



        },
        mounted: async function () {
            if (!this.is_consignatario)
                await this.carga_datos();
            this.$root.$on("cambiaravatar", new_avatar => {
                this.avatar = new_avatar;
            });
            this.avatar = this.$local_storage.get("avatar");

        }
    };
    </script>

    <style scoped>
    .v-menu__content .v-list--nav .v-list-item {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 5px;
        text-decoration: none;
    }

    .v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
        padding-left: 10px !important;
    }
    </style>
